import React, { Component } from "react"
import styled from "styled-components"
import FeatureIcon from "./FeatureIcon"

const HomeFeatureSetListWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  max-width: 1200px;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;

  @media (max-width: 768px) {
    align-items: flex-start;
    justify-content: flex-start;
  }

  @media (max-width: 615px) {
    justify-content: center;
    width: 100%;
  }
`

const HomeFeatureSetItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin: 10px 5px;
  width: 47%;

  @media (max-width: 980px) {
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 768px) {
    width: 42%;
    margin: 10px 12px;
    flex-direction: column;
  }

  @media (max-width: 480px) {
    flex-direction: column;
    width: 45%;
    margin: 5px;
  }
`

const HomeFeatureSetItemIcon = styled.div`
  display: flex;
  align-self: center;
  position: relative;

  @media (max-width: 980px) {
    transform: scale(0.6);
    width: 30%;
  }

  @media (max-width: 768px) {
    left: -5%;
    width: 10%;
  }

  @media (max-width: 480px) {
    left: -10%;
    transform: scale(0.5);
  }
`
const HomeFeatureSetItemContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin-left: 30px;
  width: 100%;

  @media (max-width: 980px) {
    margin-left: 10px;
  }

  @media (max-width: 768px) {
    margin-left: 0px;
    font-size: 13px;
    line-height: 19px;
  }

  @media (max-width: 480px) {
    text-align: center;
    font-size: 12px;
    line-height: 15px;
    margin: 0px;
    margin-top: -10px;
  }
`

const HomeFeatureSetItemName = styled.h5`
  line-height: 21px;
  max-width: 100%;
  @media (max-width: 980px) {
    line-height: 20px;
  }
  @media (max-width: 768px) {
    text-align: center;
    margin: 0 auto;
    line-height: 19px;
  }

  @media (max-width: 480px) {
    line-height: 16px;
  }
`

const HomeFeatureSetItemDescription = styled.p`
  font-size: 15px;
  line-height: 21px;
  max-width: 100%;

  @media (max-width: 980px) {
    font-size: 14px;
    line-height: 20px;
  }

  @media (max-width: 768px) {
    text-align: center;
    margin: 0 auto;
    font-size: 13px;
    line-height: 19px;
  }

  @media (max-width: 480px) {
    font-size: 12px;
    line-height: 16px;
  }
`

const HomeFeatureSetItemLink = styled.a`
  font-size: 15px;

  @media (max-width: 980px) {
    font-size: 14px;
    line-height: 20px;
  }

  @media (max-width: 768px) {
    text-align: center;
    margin: 0 auto;
    font-size: 13px;
    line-height: 19px;
  }

  @media (max-width: 480px) {
    margin: 0 auto;
    margin-top: 5px;
    font-size: 12px;
    line-height: 15px;
  }
`

const HomeFeatureSetList = ({ features }) => {
  if (!features || features.length < 1) {
    return null
  }
  return (
    <HomeFeatureSetListWrapper>
      {features.map((feature, index, props) => (
        <HomeFeatureSetItemWrapper key={index}>
          <HomeFeatureSetItemIcon>
            <FeatureIcon name={feature.iconName} />
          </HomeFeatureSetItemIcon>
          <HomeFeatureSetItemContent>
            <HomeFeatureSetItemName>
              {feature.featureName}
            </HomeFeatureSetItemName>
            <HomeFeatureSetItemDescription>
              {feature.featureDescription}
            </HomeFeatureSetItemDescription>
            <HomeFeatureSetItemLink href={feature.featureLink}>
              {feature.featureLinkText}
            </HomeFeatureSetItemLink>
          </HomeFeatureSetItemContent>
        </HomeFeatureSetItemWrapper>
      ))}
    </HomeFeatureSetListWrapper>
  )
}

export default ({ features }) => <HomeFeatureSetList features={features} />



// WEBPACK FOOTER //
// ./src/components/HomeFeatureSetList.js